import styled from 'styled-components';

export const PicsPlusContainer = styled.div`
  background: white;
  padding: 32px 32px 40px 32px;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
`;

export const PicsPlusHeader = styled.h1`
  font-size: 48px;
  font-weight: 800;
  line-height: 1;
  font-family: 'Inter', sans-serif;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #ff6b9d 0%, #ffa06b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  @media screen and (max-width: 500px) {
    font-size: 36px;
  }
`;

export const PicsPlusHeader2 = styled.h2`
  font-size: 22px;
  font-weight: 500;
  line-height: 1.4;
  font-family: 'Inter', sans-serif;
  color: #666;
  margin-bottom: 16px;
  @media screen and (max-width: 500px) {
    font-size: 18px;
  }
`;

export const EmojiBullet = styled.span`
  font-size: 28px;
  line-height: 1;
  display: inline-block;
  min-width: 28px;
  @media screen and (max-width: 500px) {
    font-size: 24px;
    min-width: 24px;
  }
`;

export const PicsPlusListItem = styled.li`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: flex-start;
`;

export const PicsPlusListItemHeader = styled.p`
  font-size: 18px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  margin-bottom: 4px;
  color: #222;
  line-height: 1.3;
  @media screen and (max-width: 500px) {
    font-size: 16px;
  }
`;

export const PicsPlusText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin: 0;
  font-weight: 400;
`;

export const PicsPlusAnnualSubBox = styled.div`
  border-radius: 16px;
  background: linear-gradient(135deg, #fff5f7 0%, #fff9f5 100%);
  border: 3px solid #ffb5d5;
  text-align: center;
  font-family: 'Inter', sans-serif;
  padding: 24px;
  margin-top: 32px;
  margin-bottom: 20px;
`;

export const PicsPlusAnnualSubBoxHeader = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

export const PicsPlusAnnualSubBoxDate = styled.p`
  color: #ff6b9d;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  margin: 0;
`;
export const PicsPlusAnnualSubBoxText = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
`;

// export const OptOutLink = styled(Link)`
export const OptOutLink = styled.span`
  color: #999;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-decoration-line: underline;
  white-space: pre-line;
  margin-top: 16px;
  cursor: pointer;
  &:hover {
    color: #666;
  }
`;

export const CartCheckoutButton = styled.button`
  display: inline-block;
  padding: 16px 24px;
  margin-top: 0;
  border: none;
  background: linear-gradient(135deg, #ff6b9d 0%, #ffa06b 100%);
  font-weight: 700;
  color: #fff;
  text-align: center;
  text-decoration: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.3);
  &:hover {
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 157, 0.4);
  }
  &:focus {
    outline: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:hover {
      transform: none;
    }
  }
`;

// Secondary button for balanced UX - decline action should be equally accessible
export const SecondaryButton = styled.button`
  display: inline-block;
  padding: 14px 24px;
  margin-top: 0;
  border: 2px solid #ddd;
  background: transparent;
  font-weight: 600;
  color: #666;
  text-align: center;
  text-decoration: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  font-size: 16px;
  min-height: 48px;

  &:hover {
    border-color: #999;
    color: #444;
    background: #f9f9f9;
  }
  &:focus {
    outline: 2px solid #ff6b9d;
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
